import { jsx as _jsx } from "react/jsx-runtime";
import { Popover as AntPopover } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
const PopoverComponent = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { className, key, ...rest } = props;
    return /*#__PURE__*/ _jsx(AntPopover, {
        overlayClassName: className,
        ref: ref,
        ...rest
    });
});
PopoverComponent.displayName = 'PopoverComponent';
export const Popover = styled(PopoverComponent)`
  &,
  .ant-popover-inner {
    [data-new-theme-enabled='true'] & {
      border-radius: var(--padding-01);
    }
  }
  .ant-popover-inner-content {
    padding: 0;
  }

  .ant-popover-arrow {
    display: none;
  }

  cursor: ${({ isDisabled })=>isDisabled ? 'not-allowed' : 'pointer'};
`;
const DefaultPopover = AntPopover;
export { DefaultPopover };
